import React, { memo, useState, useRef, useEffect, useCallback } from "react";
import "./InteractiveMap.css";
import { Col } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { handlingCatchError } from "../../../../Utils/ErrorHandling";
import { useLocation, useNavigate } from "react-router-dom";
import markerImg from "../../../../Assets/Images/orange-home.png";
import "mapbox-gl/dist/mapbox-gl.css";
import Map, {
  Marker,
  Source,
  Layer,
  NavigationControl,
  Popup,
} from "react-map-gl";
import FmdGoodOutlinedIcon from "@mui/icons-material/FmdGoodOutlined";
import WebMercatorViewport from "viewport-mercator-project";
import Profile from "../Profile/Profile";
import { FilterLayout } from "../../../Layouts/LoggedInLayout/FilterLayout";
import ConstantData from "../../../../Utils/Constant.js";
import MarketProperty from "../../../HelperComponent/MarketProperty";
import { renderAsserDataBasedOnTypeId } from "../../../../helpers/componentHelper";
import { render } from "react-dom";
import { apiCommonTrigger } from "../../../../Utils/apiServicehelper.js";
import { Config } from "../../../../Utils/Config.js";
import { commonFormatNumber, getTrafficLineWidth } from "../../../../helpers/dataHelper.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { withStyles } from "@mui/styles";
import { Tooltip } from "@mui/material";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { buildTrafficLayer } from "../../../../helpers/TrafficGroupingHelper.js";
const pinStyle = {
  cursor: "pointer",
  fill: "#d00",
  stroke: "none",
};
const applyToArray = (func, array) => func.apply(Math, array);
var supplyExtp = [];
var supplyCircles = {};
var demandExtp = [];
var demandCircles = {};
const InteractiveMap = memo((props) => {
  const [isLoading, setLoading] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [supplyRadius, setSupplyRadius] = useState(0);
  const [demandRadius, setDemandRadius] = useState(0);
  const mapRef = useRef();

  const [marketData, setMarketData] = useState([]);
  const [filterByOptions, setFilterByOptions] = useState([]);
  const marketId = location.pathname.split("/").pop();
  const [viewport, setViewPort] = useState({
    width: "100%",
    height: "100vh",
    longitude: -97.86589,
    latitude: 37.70959,
    zoom: 3.5,
    cursor: "pointer",
  });
  const [marketInfo, setMarketInfo] = useState({});
  // var marketInfo = null;
  const [profile, setProfile] = useState({ showProfile: false });
  const [devprofileid,setDevprofileid]=useState();
  const [profileInfo, setProfileInfo] = useState({});
  // const[loaddev,setLoaddev]=useState([]);
  const [trackedField, setTrackedFields] = useState({
    marketCenter: true,
    "Large Ops": true,
    "Mid Ops": true,
    "Small Ops": true,
    "Single Ops": true,
  });
  const [popupInfo, setPopupInfo] = useState(false);
  const [profileAddress, setProfileAddress] = useState("");
  const [assertPopType , setAssertPopType] = useState(null);
  const [assertPinData , setAssertPinData] = useState(null);
  const [assertLatLong , setAssertLatLong] = useState({lat : null , lng : null});
 const developmentFilters = useSelector((state) => state.developmentFilters);
  const activeCheckList = useSelector((state) => state.activeCheckList);
  const activeTileSet = useSelector((state) => state.activeTileSet);
  const [trafficCounts,setTrafficCounts]=useState([]);
  const [trafficCountsIndex,setTrafficCountsIndex]=useState([])
  const [trafficColorExp, setTrafficColorExp] = useState([]);
  
 const InfoPopup = withStyles(() => ({
      tooltip: {
        color: "white",
        letterSpacing: "1px",
        backgroundColor: "#6c757d",
        opacity: 1,
        fontSize: "11px",
        fontWeight: 400,
      },
    }))(Tooltip);
 
  const [filter, setFilter] = useState({
    showby: null,
    filterBy: []
  })
  const dispatch = useDispatch();
  const prevCenterRef = useRef(null); 
  const needsUpdateRef = useRef(null); 
  const preventIdleRef = useRef(true);
  //change center point on lat lng  changed
  const handleViewportChange = useCallback((newViewport) =>
    setViewPort(newViewport)
  );

  const fetchFilterbyOptions = () => {
    const selectedId = 1;
    apiCommonTrigger("get" , Config.API_URL + "/Lookup/maptypes")
      .then((res) => {
        if (res.status === 200) {
          const options = res.data;
          setFilterByOptions(options);
        } else {
          handlingCatchError(res, navigate);
        }
      })
      .catch((err) => {
        handlingCatchError(err, navigate);
      });
  };
  useEffect(() => {
    dispatch({ type: "viewPort", value: viewport });
  }, [viewport]);

  useEffect(()=>{
    dispatch({type:"RESET_MAP_OVERLAYS_STATE"});
    dispatch({type:"isTrafficReset",value:false})
      return ()=>{
      dispatch({type:"RESET_MAP_OVERLAYS_STATE"})
      dispatch({type:"isTrafficReset",value:false})
    }
  },[location.pathname])

  useEffect(() => {
    fetchFilterbyOptions();
    dispatch({ type: 'developmentFilters', value: [] });
    const filterResetBtn = document.getElementById("reset-btn-filter");
    if (filterResetBtn) filterResetBtn.click();
  }, []);

  useEffect(() => {    
    if(developmentFilters){
      getDevelopmentData(marketId , marketData);
    }
  }, [developmentFilters]);
   useEffect(() => {
    dispatch({ type: "Viewport", value: viewport });
  }, [viewport]); 

  useEffect(() => {
    if (marketId && filter) getMarketData(marketId);
  }, [filter])

  useEffect(() => {
    if(!props.getBasicDetails) return true;
   
    if (Object.keys(props.data).length > 0 && props.data.id === parseInt(props.marketId)) {   
      // when user change from one market to another, closing the profile 1st
      setProfile({
        ...profile,
        showProfile: false,
      });

      setViewPort({
        ...viewport,
        latitude: props.data.latitude,
        longitude: props.data.longitude,
      });
      setDemandRadius(props.data.demandradius);
      setSupplyRadius(props.data.supplyradius);
      getSupplyCircle(
        props.data.latitude,
        props.data.longitude,
        props.data.supplyradius,
        props.data.demandradius
      );
      getDemandCircle(
        props.data.latitude,
        props.data.longitude,
        props.data.demandradius,
        props.data.supplyradius
      );
      setMarketInfo(props.data);
      getMarketData(marketId);
    } else {

      // when user change from one market to another, closing the profile 1st
      setProfile({
        ...profile,
        showProfile: false,
      });

      props.getBasicDetails(props.marketId);
    }
  }, [props.data, props.marketId]);

  //show market profile popup
  const toggleProfile = useCallback(
    (show) => {
      if (show) {
        setProfile((prev) => {
          return {
            ...prev,
            showProfile: show,
          };
        });
      } else {
        setProfile({
          ...profile,
          showProfile: false,
        });
      }
    },
    [profile.showProfile]
  );

  //get interactive map data
  const getMarketData = async (profileId) => {
    setLoading(true);
    const newParksData = [];

    const radioId = filter.showby;
    const ops = filter.filterBy.filter(item => item.typeid === 1 && item.isactive).map(item => item.id);
    const koa = filter.filterBy.filter(item => item.typeid === 2 && item.isactive).map(item => item.id);
    const glamping = filter.filterBy.filter(item => item.typeid === 3 && item.isactive).map(item => item.id);

    if (!radioId) return false;
    let inputData= {
        "showby": radioId,
        "koafilters": koa.join(","),
        "sizefilters": ops.join(","),
        "glampingfilters": glamping.join(","),
        "marketid": profileId,
        "isdemo" : false,
      }
     
    await apiCommonTrigger("post",`${Config.API_URL}/markets/market/pois`,inputData).then((res) => {
      setLoading(false);
      if (res.status === 200) {
        for (let feature of res.data.features) {
          feature.data.typeid = feature.typeid
          feature.data.isdisplay = true;
          newParksData.push(feature.data);
        }
        newParksData.sort((a, b) => b.features.length - a.features.length);
        if(developmentFilters) getDevelopmentData(marketId ,newParksData);
        else setMarketData(newParksData);
        
      } else {
        handlingCatchError(res, navigate);
      }
    })
      .catch(err => {
        handlingCatchError(err, navigate);
      })
  };

  const getDevelopmentData = async (marketId , marketDataUpdated) => { 
  let renderList = Array.isArray(marketDataUpdated) ? [...marketDataUpdated] : [];
    try{
    for (const obj of developmentFilters) {
      const exists = renderList.some(objs => objs.typeid === obj.id);
      if (!exists && !obj.isBool) {
        const developmentres = await apiCommonTrigger("post",`${Config.API_URL}/Markets/interactivemapadditionalassets`, {
            typeid: obj.id,
            marketid: parseInt(marketId),
          })
        if (developmentres.status === 200) {
          obj.isBool = true;
          obj.data = developmentres.data;
          developmentres.data.isdisplay = true;
          developmentres.data.typeid = obj.id;
          renderList.push(developmentres.data);
        } else {
          handlingCatchError(developmentres, navigate);
        }
      }else if (!exists){
        renderList.push(obj.data);
      }else if (obj?.data?.isdisplay === false) {
        const item = renderList.find(valObj => valObj.typeid === obj.id);
        if (item) {
          item.isdisplay = false;
        }
      }
      else{
        const item = renderList.find(valObj => valObj.typeid === obj.id);
        if (item) {
          item.isdisplay = true;
        }
      }
    
  }
    setMarketData(renderList);
}catch(error){
      handlingCatchError(error);
  };
}
 const getDevelopmentInfo = async (typeId , profileId, latitude, longitude) => {
  try{
 let inputData={
          assetid: typeId,
          pinid: profileId,
        }
      const developmentres = await apiCommonTrigger("post",`${Config.API_URL}/Maps/pois/assets/info`,inputData)
      const pinResult = developmentres.data[0];
      setAssertLatLong({lat : latitude , lng : longitude});
      setAssertPinData(pinResult);
      setAssertPopType(typeId);
      setProfile({ ...profile, showProfile: false });
  }
  catch(error){
    handlingCatchError(error);
  }
 
};

  const generateMapboxColorExpression = (property, colorData, colorType, defaultColor) => [
    'case',
    ...colorData.flatMap(c => [['==', ['get', property], c.name], c[colorType]]),
    defaultColor
  ];

  //draw circle
  const getDemandCircle = (dLat, dLong, radius, supplyRadi) => {
    demandCircles = {};
    let radiusCal = radius;
    let lat = dLat;
    let lng = dLong;
    let dir = 1;
    var d2r = Math.PI / 180;
    var r2d = 180 / Math.PI;
    var earthsradius = 3963;
    var points = 64;
    // find the raidus in lat/lon
    var rlat = (radiusCal / earthsradius) * r2d;
    var rlng = rlat / Math.cos(lat * d2r);

    demandExtp = [];
    if (dir === 1) {
      var start = 0;
      var end = points + 1;
    } else {
      var start = points + 1;
      var end = 0;
    }
    for (var i = start; dir === 1 ? i < end : i > end; i = i + dir) {
      var theta = Math.PI * (i / (points / 2));
      let ey = lng + rlng * Math.cos(theta);
      let ex = lat + rlat * Math.sin(theta);
      demandExtp.push([ey, ex]);
    }
    demandCircles = {
      type: "Feature",
      geometry: {
        type: "LineString",
        coordinates: demandExtp,
      },
    };
    if (radius > supplyRadi) {
      getBoundingValues(demandCircles);
    }
  };

  //calculate bounding box value for circle default adjustment
  const getBoundingValues = (points) => {
    if (points) {
      const pointsLong = points.geometry.coordinates.map((point) => point[0]);
      const pointsLat = points.geometry.coordinates.map((point) => point[1]);
      const cornersLongLat = [
        [applyToArray(Math.min, pointsLong), applyToArray(Math.min, pointsLat)],
        [applyToArray(Math.max, pointsLong), applyToArray(Math.max, pointsLat)],
      ];
      const viewport = new WebMercatorViewport({
        width: window.innerWidth,
        height: window.innerHeight,
      }).fitBounds(cornersLongLat, {
        padding: { top: 100, bottom: 100, left: 100, right: 100 },
      });
      const { longitude, latitude, zoom } = viewport;
      setViewPort({
        ...viewport,
        latitude: latitude,
        longitude: longitude,
        zoom: zoom - 0.5,
      });
    }
  };

  //draw circle
  const getSupplyCircle = (sLat, sLng, radius, demandRadi) => {
    supplyCircles = {};
    let radiusCal = radius;
    let lat = sLat;
    let lng = sLng;
    let dir = 1;
    var d2r = Math.PI / 180;
    var r2d = 180 / Math.PI;
    var earthsradius = 3963;
    var points = 64;
    // find the raidus in lat/lon
    var rlat = (radiusCal / earthsradius) * r2d;
    var rlng = rlat / Math.cos(lat * d2r);

    supplyExtp = [];
    if (dir === 1) {
      var start = 0;
      var end = points + 1;
    } else {
      var start = points + 1;
      var end = 0;
    }
    for (var i = start; dir === 1 ? i < end : i > end; i = i + dir) {
      var theta = Math.PI * (i / (points / 2));
      let ey = lng + rlng * Math.cos(theta);
      let ex = lat + rlat * Math.sin(theta);
      supplyExtp.push([ey, ex]);
    }
    supplyCircles = {
      type: "Feature",
      geometry: {
        type: "LineString",
        coordinates: supplyExtp,
      },
    };
    if (radius > demandRadi || radius === demandRadi) {
      getBoundingValues(supplyCircles);
    }
  };

  //get profile details for selected pins
  const getcoordinates = (event) => {
    preventIdleRef.current = true;
    let latitude = event.lngLat[1];
    let longitude = event.lngLat[0];
    if (event.features[0] && event.features[0].layer.type === "circle") {
      const featureId = event.features[0].properties.facilityid || event.features[0].properties.id || event.features[0].id
      setDevprofileid(featureId);
      setProfileInfo({
        ...profileInfo,
        profileInfo: event.features[0].properties,
      });
      if (ConstantData.devtypeid.typeid.includes(event.features[0].properties.typeid)) {
      const featureId = event.features[0].properties.facilityid || event.features[0].properties.id || event.features[0].id;
      getDevelopmentInfo(event.features[0].properties.typeid , featureId ,latitude, longitude)
      return true;
      } else {
        setProfile({ ...profile, showProfile: true });
      }    
    }
};

  // display pins based on selection
  useEffect(() => {
  }, [marketData]);
   useEffect(() => {
    const map = mapRef.current?.getMap();
    if (!map || !activeTileSet) return;
  
    setTimeout(() => {
      const allLayers = map.getStyle().layers;
      const referenceLayer = allLayers.find(
        l =>
          l.type === "symbol" &&
          l.id.includes("label")
      );
      const beforeId = referenceLayer?.id;
  
      const orderedLayers = [
        "tile-fill-layer",
        "tile-border-layer",
        "tile-line-layer",
      ];
  
      orderedLayers.forEach((layerId) => {
        if (map.getLayer(layerId) && beforeId) {
        
          try {
           
            map.moveLayer(layerId, beforeId);
          } catch (err) {
            console.warn(`Failed to move ${layerId}`, err);
          }
        }
      });
    }, 100);
  }, [activeTileSet]);

  const getDataFromChild = async (showby, filterBy) => {

    const filterOptions = {
      ...filter,
      showby: showby.toString(),
      filterBy: filterBy
    };
    setFilter(filterOptions);

    return true;
  }

  //reverse geo coding for get market center;
  const callGeocoding = async (latitude, longitude) => {
    await fetch(
      "https://api.mapbox.com/geocoding/v5/mapbox.places/" +
      longitude +
      "," +
      latitude +
      ".json?access_token=" +
      process.env.REACT_APP_MAPBOX_TOKEN,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        setProfile({ ...profile, showProfile: false });
        setProfileAddress({
          ...profileAddress,
          profileAddress:
            data.features.length > 0 ? data.features[0].place_name : "",
        });
        setPopupInfo(true);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };
  
  const handleTrafficCountsLayer = () => {
    const map = mapRef.current?.getMap();
    const layerId = 'tile-line-layer';
    const shapeID = activeTileSet?.shapeid; 
    const zoom = viewport?.zoom;
    if(zoom < ConstantData.advancedMapOverlaysIds.trafficZoomLevel) return;
    const colorCodes = activeTileSet.colorCodes.map(c => c.fillcolor);
    const { binData, legends, legendIndexes, colorExpr } = buildTrafficLayer({
           map,
           layerId,
           shapeID,
           zoom,
           colorCodes,
        });
    setTrafficCounts(legends);
    setTrafficCountsIndex(legendIndexes);
    setTrafficColorExp(colorExpr)

};

// useEffect(() => {
//   const map = mapRef.current?.getMap();
//   if (!map || activeTileSet?.layertype !== "line" || viewport.zoom < ConstantData.advancedMapOverlaysIds.trafficZoomLevel) return;

//   const layerId = "tile-line-layer";
//   let hasUpdated = false;

//   const checkAndUpdate = () => {
//     if (hasUpdated) return;
//     if (!map.getLayer(layerId)|| viewport.zoom < 10) return;
//     const features = map.queryRenderedFeatures({ layers: [layerId] });
//     if (features.length > 0) {
//       handleTrafficCountsLayer(); 
//       hasUpdated = true;
//     } else {
//       setTrafficCounts([])
//       setTrafficCountsIndex([])
//       map.once("sourcedata", checkAndUpdate);
//     }
//   };

//   checkAndUpdate();

//   return () => {
//     hasUpdated = true;
//   };

// }, [activeTileSet]);

const clearTrafficData = () => {
      setTrafficCounts([]);
      setTrafficCountsIndex([]);
      needsUpdateRef.current = false;
};

useEffect(()=>{
    const map = mapRef.current?.getMap();
    if (!map || activeTileSet?.layertype !== "line" || viewport.zoom < 10) return;
    const layerId = "tile-line-layer";
    const sourceId = `fema-tileset-${activeTileSet?.sourcelayer}`;

    const runUpdateSafely = (bool = false) => {
      if(bool) {
        preventIdleRef.current = false;
      } else {
        preventIdleRef.current = true;
      }
      const features = map.queryRenderedFeatures({ layers: [layerId] });
        if (features.length > 0) {
          // if (shouldUpdateBasedOnDistance(map, prevCenterRef)) {
            handleTrafficCountsLayer();
            prevCenterRef.current = map.getCenter();
            needsUpdateRef.current = false;
          // }
        } else {
          clearTrafficData()
        }
        needsUpdateRef.current = false;
    };

    const requestUpdate = () => {
      needsUpdateRef.current = true;
      if(preventIdleRef.current) runUpdateSafely(true);
    };

    // viewport move/zoom
    const handleMoveEnd = () => {
      needsUpdateRef.current = true;
      // wait until tiles settle
      map.once("idle", () => {
        if (needsUpdateRef.current) {
          runUpdateSafely();
        }
      });
    };

    // tiles loaded
    const handleSourceData = (e) => {
      if (e.sourceId === sourceId && e.isSourceLoaded && needsUpdateRef.current) {
        if (needsUpdateRef.current) runUpdateSafely();
      }
    };

    map.on("moveend", handleMoveEnd);
    map.on("idle", requestUpdate)
    map.on("sourcedata", handleSourceData);

    return () => {
      map.off("moveend", handleMoveEnd);
      map.off("idle", requestUpdate);
      map.off("sourcedata", handleSourceData);
    };
},[activeTileSet,viewport])


const legendItems = activeTileSet ? activeTileSet?.layertype === "line"
? activeTileSet.colorCodes?.filter((_, i) =>trafficCountsIndex.includes(i))
: activeTileSet?.colorCodes : [] 
  return (
    <div style={{position: 'relative'}}>
      {isLoading ? (
        <div className="loader-wrap">
          <div className="loading loading-center"></div>
        </div>
      ) : (
        ""
      )}
      <div className="interactive-map">

        { !profile.showProfile && 
          <div id="legend-filter" className="filter-by-map">
            <div className="mymarkets-submenu filter-by-submenu"><FilterLayout fetchDataFromChild={getDataFromChild} pageType={"intractive"} /></div>
          </div>
        }

        <Map
          {...viewport}
          ref={mapRef}
          onClick={getcoordinates}
          onViewportChange={handleViewportChange}
          getCursor={(e) => "pointer"}
          mapboxApiAccessToken={process.env.REACT_APP_MAPBOX_TOKEN}
          mapStyle="mapbox://styles/mapbox/streets-v11"
        >
          <div className="zoom-plus-minus">
            <NavigationControl showCompass={false} showZoom={true} />
          </div>
          <Source id="route1" type="geojson" data={supplyCircles} />
          <Layer
            type="line"
            source="route1"
            layout={{
              "line-join": "round",
              "line-cap": "round",
            }}
            paint={{
              "line-color": "#000000",
              "line-width": 2,
            }}
          />
          <Source id="route2" type="geojson" data={demandCircles} />
          <Layer
            type="line"
            source="route2"
            layout={{
              "line-join": "round",
              "line-cap": "round",
            }}
            paint={{
              "line-color": "#000000",
              "line-width": 2,
            }}
          />

          {marketData.length > 0 && marketData.map((data, index) => {
            if (data.isdisplay) {
              
              return (
              <Source key={index} id={`source-${index}`} type="geojson" data={data}>
                <Layer
                  id={`layer-${index}`}
                  type="circle"
                  source={`source-${index}`}
                  paint={{
                    "circle-radius": 4,
                    "circle-color": ["get", "colorcode"],
                  }}
                />
              </Source>
            
            );
          }
          })}



          {trackedField &&
            trackedField.marketCenter &&
            marketInfo &&
            marketInfo.latitude &&
            marketInfo.longitude ? (
            <Marker
              longitude={marketInfo.longitude}
              latitude={marketInfo.latitude}
              onClick={() => {
                if (marketInfo.profileid !== null) {
                  setProfileInfo({ ...profileInfo, profileInfo: marketInfo }),
                    setProfileAddress({
                      ...profileAddress,
                      profileAddress: "",
                    });
                  setPopupInfo(false);
                  setProfile({ ...profile, showProfile: true });
                } else {
                  callGeocoding(marketInfo.latitude, marketInfo.longitude);
                }
              }}
            >
              <img
                src={markerImg}
                alt="Market Pin"
                height={20}
                viewBox="0 0 24 24"
                style={{
                  ...pinStyle,
                  transform: `translate(${-10 / 2}px,${-10}px)`,
                }}
              ></img>
            </Marker>
          ) : (
            ""
          )}

          {/* <Legend legendType={[]} supplyRadius={supplyRadius} demandRadius={demandRadius} /> */}

          {popupInfo &&
  marketInfo &&
  marketInfo.latitude &&
  marketInfo.longitude && (
    <Popup
      anchor="top"
      longitude={marketInfo.longitude}
      latitude={marketInfo.latitude}
      onClose={() => setPopupInfo(false)}
      className="info-market-popup"
    >
      <div>
        <p className="address-section">
          <FmdGoodOutlinedIcon />
          {profileAddress?.profileAddress || ""}
        </p>
      </div>
    </Popup>
)}
 {assertPinData && assertLatLong?.lng &&
                    <Popup
                        anchor="top"
                        longitude={assertLatLong.lng}
                        latitude={assertLatLong.lat}
                        onClose={() => {
                          setAssertLatLong({lat : null , lng : null});
                        }}
                        className="info-market-popup"
                      > 
                       {renderAsserDataBasedOnTypeId( assertPopType , assertPinData)}
                     
                      </Popup>
                  }
                  
 {/* === Advanced Map Overlays === */}
      {activeTileSet &&
         <Source
            id={`fema-tileset-${activeTileSet?.sourcelayer}`} 
            type="vector"
            url={`mapbox://${activeTileSet?.tilesetid}`}
            key={activeTileSet?.sourcelayer}
          >
            {activeTileSet?.layertype === "line" && viewport.zoom >= ConstantData.advancedMapOverlaysIds.trafficZoomLevel &&
              <Layer
                id={`tile-line-layer`}
                type="line"
                source={`traffic-tileset`}
                source-layer={activeTileSet.sourcelayer}
                paint={{
                  'line-color': trafficColorExp.length ? trafficColorExp : activeTileSet?.fillcolor,  
                  'line-width': getTrafficLineWidth(viewport.zoom)
                }}
            />}

           {activeTileSet?.layertype === "tileset" && (() => {        
            const isEOZ = activeTileSet?.id === ConstantData.advancedMapOverlaysIds.eoz;
            const tileFilterKey = activeTileSet?.TileFilter?.lableid;
            const propertyName = isEOZ ? 'TRACTTYPE' : `${tileFilterKey}_RISKR`;

            const hasFilter = isEOZ ? true : Boolean(activeTileSet?.TileFilter && tileFilterKey);
            
            const fillPaint = hasFilter
              ? {
                  'fill-color': generateMapboxColorExpression(propertyName, activeTileSet.colorCodes, 'fillcolor', '#fff'),
                  'fill-opacity': 0.8,
                  'fill-outline-color': generateMapboxColorExpression(propertyName, activeTileSet.colorCodes, 'bordercolor', '#999999'),
                }
              : {
                  'fill-color': activeTileSet?.fillcolor || '#ffffff',
                  'fill-outline-color': activeTileSet?.bordercolor || '#999999',
                  'fill-opacity': 0.8,
                };

            const borderPaint = hasFilter
              ? {
                  'line-color': generateMapboxColorExpression(propertyName, activeTileSet.colorCodes, 'bordercolor', '#999999'),
                  'line-width': 0.5,
                  'line-opacity': 0.8,
                }
              : {
                  'line-color': activeTileSet?.bordercolor || '#999999',
                  'line-width': 1,
                  'line-opacity': 0.8,
                };

            const layerFilter = hasFilter
              ? ['all', ['!=', ['get', propertyName], null]]
              : true;

            return (
              <>
                <Layer
                  id="tile-fill-layer"
                  type="fill"
                  source={`fema-tileset-${activeTileSet?.sourcelayer}`}
                  source-layer={activeTileSet?.sourcelayer}
                  paint={fillPaint}
                  filter={layerFilter}
                />
                <Layer
                  id="tile-border-layer"
                  type="line"
                  source={`fema-tileset-${activeTileSet?.sourcelayer}`}
                  source-layer={activeTileSet?.sourcelayer}
                  paint={borderPaint}
                  filter={layerFilter}
                />
              </>
            );
          })()}
        </Source>}

      </Map>
      </div>
  

      <div className="mapbox-maps map-box-info">
        {profile.showProfile && profileInfo && profileInfo.profileInfo ? (
          <Col className="market-tabs-popup p-0">
            <Profile
              profileData={profileInfo}
              toggleProfile={toggleProfile}
              isFrom="map"

            />
          </Col>
        ) : null}
      </div>
      {/* Hazard Legend code */}
                  {((activeTileSet?.TileFilter?.id || activeTileSet?.id === ConstantData.advancedMapOverlaysIds.eoz ) || (activeTileSet?.layertype === "line" && viewport.zoom >= ConstantData.advancedMapOverlaysIds.trafficZoomLevel && trafficCounts?.length && trafficCounts?.some(Boolean))) ? (
                    <div
                      className="hazards-legend"
                    >
                      <p style={{fontWeight:600,fontSize:"14px", gridColumn: '1 / -1'}}>
                      {activeTileSet?.TileFilter?.id ? activeTileSet?.TileFilter?.labletext : activeTileSet.name}
                        {activeTileSet?.layertype === "line" && viewport.zoom >= ConstantData.advancedMapOverlaysIds.trafficZoomLevel ? "- AADT":""} {activeTileSet?.layertype === "line"&&viewport.zoom >= ConstantData.advancedMapOverlaysIds.trafficZoomLevel ? 
                        <InfoPopup 
                          interactive 
                          arrow 
                          onOpen={()=>preventIdleRef.current=false}
                          placement='top' 
                          title={<div style={{ width: '240px' }}>
                                      <strong >Annual Average Daily Traffic (AADT)</strong>
                                      <p style={{marginTop:"5px"}} className="mb-0">Average number of all motor vehicles using a road each day, based on annual data from state transportation departments.</p>
                                  </div>
                                }
                        >
                            <span className='summary-kd-info pl-1'>
                              <FontAwesomeIcon icon={faInfoCircle} style={{fontSize:"18px"}} />
                            </span>
                        </InfoPopup> :""} 
                      </p>
                      {legendItems?.map((item, i) => {
                         const isTraffic = activeTileSet?.layertype === "line";
                        return (
                          <div className="hazards-div" key={i}>
                            <p
                              style={{
                                height: "10px",
                                width: "10px",
                                boxShadow: "0 0 1px 1px #c9c9c9",
                                backgroundColor: item?.fillcolor,
                                borderRadius: "10px",
                                margin: "0",
                                opacity: isTraffic ? 1 : 0.8,
                              }}
                            />
                           {!isTraffic &&  <span className="lagend-name">{item?.name}</span>}
                             {isTraffic ? <span>{trafficCounts[i]}</span> : "" }
                          </div>
                        );
                      })}
                    </div>
                  ):""}
      <MarketProperty fromPage={"map-search"} />
    </div>
  );
});

export default InteractiveMap;
